import { createSelector } from "@reduxjs/toolkit";
import { StoreState } from "../../store";

const selector = (state: StoreState) => state.home;

export const homeSelectors = {
    image: createSelector(selector, (home) => home.image),
    hotProperty: createSelector(selector, (home) => home.hot_property),
    inquiryForm: createSelector(selector, (home) => home.inquiry_form)
}
